import { useState } from 'react';
import PropTypes from 'prop-types';
import RoleplayDebriefView from './RoleplayDebriefView';

const ChevronLeft = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M10 4l-4 4 4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ChevronRight = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M6 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const CS_FIELDS = [
  { label: 'Counterpart',          getValue: cs => cs?.characterBrief?.inSum?.content },
  { label: 'Real Issue',    getValue: cs => cs?.realIssue?.summary?.content },
  { label: 'Data & Reasoning',     getValue: cs => cs?.realIssue?.dataAndReasoning?.content },
  { label: 'Stakes — Downsides',   getValue: cs => cs?.characterStakes?.downSides?.inSum?.content },
  { label: 'Stakes — Upsides',     getValue: cs => cs?.characterStakes?.upSides?.inSum?.content },
  { label: 'Challenge',            getValue: cs => cs?.challenge?.content },
];

const ImplementationPanel = ({ caseStudy, exchanges, debriefReport, onRetryDebriefBody, characterName, open, onToggle }) => {
  const [activeTab, setActiveTab] = useState('casestudy');

  return (
    <div className={`rp-script-panel ${open ? 'open' : 'closed'}`}>
      {!open && (
        <button className="rp-script-collapsed-strip" onClick={onToggle} title="Expand panel">
          <div className="rp-script-collapsed-label">Session Materials</div>
          <ChevronLeft />
        </button>
      )}

      {open && (
        <>
          <div className="rp-script-header">
            <div className="rp-script-tabs">
              <button
                className={`rp-script-tab ${activeTab === 'casestudy' ? 'active' : ''}`}
                onClick={() => setActiveTab('casestudy')}
              >
                Case Study
              </button>
              <button
                className={`rp-script-tab ${activeTab === 'gold' ? 'active' : ''}`}
                onClick={() => setActiveTab('gold')}
              >
                Gold Version
              </button>
              <button
                className={`rp-script-tab ${activeTab === 'debrief' ? 'active' : ''}`}
                onClick={() => setActiveTab('debrief')}
              >
                Debrief
              </button>
            </div>
            <button className="rp-script-toggle-inline" onClick={onToggle} title="Collapse">
              <ChevronRight />
            </button>
          </div>

          {activeTab === 'casestudy' && (
            <div className="rp-impl-casestudy">
              {CS_FIELDS.map(({ label, getValue }) => {
                const value = getValue(caseStudy);
                if (!value) return null;
                return (
                  <div key={label} className="rp-impl-cs-section">
                    <div className="rp-impl-cs-label">{label}</div>
                    <div className="rp-impl-cs-value">{value}</div>
                  </div>
                );
              })}
              {!caseStudy && (
                <p className="rp-script-empty">Case study not available.</p>
              )}
            </div>
          )}

          {activeTab === 'gold' && (
            <>
              <div className="rp-script-list">
                {exchanges.length === 0 ? (
                  <p className="rp-script-empty">No exchanges recorded.</p>
                ) : (
                  exchanges.map((ex, i) => (
                    <div
                      key={i}
                      className="rp-script-exchange"
                    >
                      <div className="rp-script-speaker-label you">You</div>
                      <p className="rp-script-text">{ex.clientText}</p>
                      <div className="rp-script-speaker-label them">{characterName || 'them'}</div>
                      <p className="rp-script-text character">{ex.characterText}</p>
                    </div>
                  ))
                )}
              </div>
              <div className="rp-script-footer">
                {exchanges.length} {exchanges.length === 1 ? 'exchange' : 'exchanges'} captured
              </div>
            </>
          )}

          {activeTab === 'debrief' && (
            <div className="rp-script-debrief-tab">
              <RoleplayDebriefView report={debriefReport} onRetryBody={onRetryDebriefBody} />
            </div>
          )}
        </>
      )}
    </div>
  );
};

ImplementationPanel.propTypes = {
  caseStudy:    PropTypes.object,
  exchanges:    PropTypes.arrayOf(
    PropTypes.shape({
      clientText:    PropTypes.string.isRequired,
      characterText: PropTypes.string.isRequired,
    })
  ).isRequired,
  debriefReport:  PropTypes.object,
  onRetryDebriefBody: PropTypes.func,
  characterName:  PropTypes.string,
  open:           PropTypes.bool.isRequired,
  onToggle:       PropTypes.func.isRequired,
};

export default ImplementationPanel;
